// Setup completion rules — all based on existing Users fields + gallery count + connect/launch flags.
export const SETUP_STEPS = [
  { key: "profile", n: 1, title: "Your Profile", blurb: "Name, photo, phone and your shop handle" },
  { key: "business", n: 2, title: "Your Business", blurb: "Business name, location and AI-written bio" },
  { key: "brand", n: 3, title: "Your Brand", blurb: "Logo and a few gallery images" },
  { key: "home", n: 4, title: "Home Page", blurb: "Build your dealer home page with AI and preview it" },
  { key: "connect", n: 5, title: "Connect", blurb: "Website, social links and Instagram (optional)" },
  { key: "money", n: 6, title: "Email & Payments", blurb: "Campaign sending and Venmo / Zelle for invoices" },
  { key: "launch", n: 7, title: "Launch", blurb: "Preview your page and go live" },
];

const has = (v) => String(v ?? "").trim().length > 0;

export function computeSetup(form, { galleryCount = 0, igConnected = false, connectSkipped = false, moneySkipped = false, launched = false } = {}) {
  const f = form || {};
  const done = {
    profile: has(f.first_name) && has(f.last_name) && has(f.phone_no) && has(f.image_url) && has(f.user_name),
    business: has(f.company_name) && has(f.city) && has(f.company),
    brand: has(f.dealer_logo) && galleryCount >= 2,
    home: has(f.home_html) || has(f.aboutus),
    connect: igConnected || has(f.dealer_instagram) || has(f.dealer_facebook) || has(f.website_url) || connectSkipped,
    money: has(f.dealer_venmo) || has(f.dealer_zelle) || moneySkipped,
    launch: launched,
  };
  const count = Object.values(done).filter(Boolean).length;
  return { done, count, total: SETUP_STEPS.length, pct: Math.round((count / SETUP_STEPS.length) * 100) };
}
